import dayjs from "dayjs";

export const MODAL_TITLE =
  "That date isn\u2019t available, try another date or similar activity";

export const SUBTITLE_WITH_NEXT_DATE = (
  nextDate: string,
  searchedDate: string,
) =>
  `The next available date is ${nextDate} or check out similar activities available on ${searchedDate} below:`;

export const SUBTITLE_WITHOUT_NEXT_DATE = (searchedDate: string) =>
  `Check out similar activities available on ${searchedDate} below:`;

export const FINDING_NEXT_DATE = "Finding the next available date...";

export const VIEW_ALL_ALTERNATIVES = "View all alternative activities";

export const formatDateDisplay = (date: string) =>
  dayjs(date).format("MMM D, YYYY");

